export default __webpack_public_path__ + "img/exit-modal-graphic.de50f22.svg";